import { combineReducers } from 'redux';

import consultarDisponibilidadeMedicoPosto from './consultarDisponibilidadeMedicoPosto/reducer';

export default combineReducers({
	consultarDisponibilidadeMedicoPosto,
});
